import { useIntl } from 'react-intl'

import { CountriesAPI } from '@api/countries'

import { initialQueryState } from '@models/apiBase'
import { Option, WithId } from '@models/option'

import { AsyncPaginateSelectField, AsyncPaginateSelectFieldProps } from '@components/Form/AsyncPaginateSelect'

import TypeUtil from '@/utils/typeUtil'

type Props<IsMulti extends boolean> = Omit<AsyncPaginateSelectFieldProps<IsMulti>, 'onSearch'>

const CountrySelectField = <IsMulti extends boolean = false>(props: Props<IsMulti>) => {
  const intl = useIntl()
  const searchDebounce = async (inputVal: string, page: number) => {
    const response = await CountriesAPI.getOptions({
      ...initialQueryState,
      page: page,
      limit: 10,
      phrase: !TypeUtil.isEmpty(inputVal) ? inputVal : undefined,
    })

    if (response.data) {
      return {
        ...response.data,
        nodes: response.data.nodes.map(
          (country) =>
            new Option<WithId>({
              label: country.name,
              value: country.name,
              data: {
                id: country.id,
              },
            })
        ),
      }
    }
  }

  return (
    <AsyncPaginateSelectField
      {...props}
      onSearch={searchDebounce}
      noOptionsMessage={() => intl.formatMessage({ id: 'patient.country_not_found' })}
    />
  )
}

export { CountrySelectField }
